import React from 'react';
import PropTypes from 'prop-types';
import classes from './EditBox.module.css';
import DraggableIcon from './DraggableIcon';

import { Draggable } from 'react-beautiful-dnd';

const EditBoxProduct = (props) => {
  const { product, connector, title, index } = props;
  const draggableId = connector
    ? `draggable-${connector}-${title}-${product.id}`
    : `draggable-${title}-${product.id}`;

  return (
    <Draggable key={draggableId} draggableId={draggableId} index={index}>
      {(provided) => (
        <span
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className={classes.editBoxIconContainer}
        >
          <DraggableIcon
            key={product.id}
            productTitle={product.Name}
            id={product.id}
            size="medium"
            category={product.category}
          />
        </span>
      )}
    </Draggable>
  );
};

EditBoxProduct.propTypes = {
  connector: PropTypes.string,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
  }),
};

export default EditBoxProduct;
